import { Auth } from 'aws-amplify';

export const getAuthIdToken = async () => {
  return await Auth.currentSession().then(res => res.getIdToken());
};

export const getCurrentUserInfo = async () => {
  const res = await Auth.currentUserInfo();
  if (!res) {
    console.log('Error: Auth.currentUserInfo() returned undefined');
  }
  return res;
};

export const isSignedIn = async () => {
  return await getAuthIdToken().then(res => !!res);
};

export const signOut = async navigate => {
  await Auth.signOut().then(res => !!res);
  localStorage.clear();
  return navigate('/');
};
